// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./img/magnify.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
}

/* VARIABLES */
:root {
  --BACKGROUND-LG: linear-gradient(rgb(75, 75, 75), rgb(54, 54, 54));
}

/* 
linear-gradient(skyblue, rgb(179, 179, 179)); sunny
linear-gradient(rgb(28, 24, 55), rgb(17, 15, 32)); clear
linear-gradient(rgb(181, 181, 181), rgb(78, 78, 78)); cloudy
linear-gradient(rgb(214, 214, 214), rgb(121, 121, 121)); blowing snow
linear-gradient(rgb(75, 75, 75), rgb(54, 54, 54)); heavy reain
 */

body {
  height: 100vh;
  background-color: dimgray;
  overflow: hidden;
}

/* HEADER */

header {
  width: 100%;
  height: 10vh;
  display: grid;
  justify-items: center;
}

/* SEARCHBR */

.search {
  width: 300px;
  display: flex;
  padding: 0.4rem;
  height: 50px;
  color: aliceblue;
}

.errorElement {
  display: grid;
  position: absolute;
  width: 290px;
  height: 2.5rem;
  padding: 0.4rem 1rem;
  border: 2px solid black;
  top: 3rem;
  border-radius: 20px;
  font-size: 1.3rem;
  opacity: 0;
  background-color: white;
  color: black;
  transition: opacity 1s ease;
  z-index: 3;
}

.searchInput {
  width: 100%;
  border: 2px solid black;
  border-radius: 20px 0 0 20px;
  padding: 0 1rem;
  font-size: 1.3rem;
  outline: none;
}
.searchButton {
  width: 70px;
  border: none;
  background: black;
  border-radius: 0 20px 20px 0;
}
.searchButton::after {
  display: block;
  margin: auto;
  height: 35px;
  width: 35px;
  content: "";
  -webkit-mask: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat 50% 50%;
  mask: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat 50% 50%;
  -webkit-mask-size: cover;
  mask-size: cover;
  background-color: white;
}
.searchButton:hover {
  background-color: white;
}
.searchButton:hover::after {
  background-color: black;
}

.visible {
  opacity: 1;
}

/* MAIN */

main {
  position: relative;
}

.mainContainer {
  height: 100%;
  width: clamp(320px, 80%, 900px);
  margin: auto;
}

.light {
  color: aliceblue;
  background: rgba(0, 0, 0, 0.199);
}

.dark {
  color: black;
  background: rgba(240, 248, 255, 0.224);
}

/* OVERVIEW */

.overviewContainer {
  padding: 1rem;
  display: grid;
  grid-template-columns: 1.5fr 1fr;
  gap: 0.4rem;
}

.nameWrapper {
  display: grid;
  grid-template-rows: 1fr min-content min-content min-content;
  align-items: center;
}
.locationCity {
  font-weight: bold;
  font-size: 1.6rem;
  align-self: end;
}
.locationCountry {
  font-weight: bolder;
  font-size: 1.2rem;
}
.localDate,
.localDate__c {
  font-size: 1.5rem;
  font-weight: bold;
  align-self: start;
}
.localTime {
  font-weight: bold;
  font-size: 1.2rem;
}
.weatherType {
  font-size: 1.2rem;
  font-weight: bold;
}

.weatherWrapper {
  display: grid;
  grid-template-columns: 1fr 1fr;
  place-items: center;
  gap: 0.2rem;
}
.temperature,
.temperature__b,
.temperature__c {
  font-weight: bold;
  font-size: 2.5rem;
  grid-column: 1 /-1;
}
.currentWeatherImg {
  border-radius: 10px;
}
.localTime,
.localTime__c {
  font-size: 1.2rem;
}
.UV,
.UV__c {
  font-size: 1.2rem;
}

/* WEATHERDETAILS */

.weatherDetailsContainer {
  display: grid;
  padding: 0 1rem 1rem 1rem;
  grid-template-columns: repeat(3, 1fr);
  grid-template-rows: repeat(3, 2rem);
  place-content: center;
  gap: 0.5rem;
  white-space: pre-line;
}
.WDSpan {
  font-weight: bold;
}

/* TOGGEL */

.toggleComponent {
  position: relative;
  width: 2.5rem;
  height: min-content;
  border-radius: 20px;
  border: 2px solid aliceblue;
  background: black;
  margin: 0 1rem 0 1rem;
}
.toggleBtn {
  position: relative;
  width: 1rem;
  height: 1rem;
  border-radius: 50%;
  background: aliceblue;
  transition: transform 0.5s ease;
}
.left {
  position: relative;
  transform: translate(0rem);
}
.right {
  position: relative;
  transform: translate(1.3rem);
}

.btnWrapper {
  display: grid;
  grid-template-columns: 1fr 1fr;
}
.showoff {
  width: max-content;
  padding: 0.1rem;
  height: 1.3rem;
  border-radius: 20px;
}

/* FORECAST */

.forecastContainer,
.forecastContainer__c {
  margin: 1rem;
  height: min-content;
  overflow-y: hidden;
  overflow-x: auto;
  display: grid;
  grid-template-columns: repeat(24, 7rem);
  border: 2px solid aliceblue;
  color: aliceblue;
}

.hourElement,
.dayElement,
.hourElement__c {
  height: 25vh;
  width: 7rem;
  padding: 0.4rem;
  display: grid;
  grid-template-rows: repeat(4, min-content);
  place-items: center;
  border-right: 2px solid aliceblue;
  transition: all 0.7s ease;
}
.hour,
.day {
  padding-bottom: 0.2rem;
  font-weight: bold;
  font-size: 1rem;
  pointer-events: none;
  white-space: nowrap;
}
.hourIcon,
.dayIcon {
  pointer-events: none;
}
.hourTemp,
.dayTemp {
  padding-top: 0.2rem;
  font-weight: bold;
  font-size: 1.2rem;
  pointer-events: none;
}
.wind {
  pointer-events: none;
}

/* FOOTER */

footer {
  height: 1.5rem;
  width: 100%;
  position: fixed;
  bottom: 0;
  display: grid;
  justify-items: center;
}

.footerA:any-link {
  color: aliceblue;
}

/* SPINNIE */

.spinnieContainer {
  display: none;
  position: fixed;
  place-items: center;
  height: 100vh;
  width: 100%;
  background-color: hsla(0, 0%, 0%, 0.749);
  overflow: hidden;
  top: 0;
  left: 0;
}

.spinnie {
  display: grid;
  place-content: center;
  position: relative;
  height: 200px;
  width: 200px;
  border-radius: 50%;
  animation: rotate 2s linear infinite;
}
.spinnieOpposite {
  display: grid;
  position: relative;
  height: 150px;
  width: 150px;
  border-radius: 50%;
  animation: rotateOpposite 1s linear infinite;
}
.spinnie::before {
  position: absolute;
  content: "";
  height: 20px;
  width: 20px;
  background-color: white;
  border-radius: 50%;
}
.spinnie::after {
  position: absolute;
  content: "";
  height: 20px;
  width: 20px;
  background-color: white;
  border-radius: 50%;
  right: 0;
}
.spinnieOpposite::before {
  position: absolute;
  content: "";
  height: 20px;
  width: 20px;
  background-color: white;
  border-radius: 50%;
}
.spinnieOpposite::after {
  justify-self: right;
  position: absolute;
  content: "";
  height: 20px;
  width: 20px;
  background-color: white;
  border-radius: 50%;
}

@keyframes rotate {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
@keyframes rotateOpposite {
  0% {
    transform: rotate(360deg);
  }
  100% {
    transform: rotate(0deg);
  }
}

/* COVER */

.detailsCover__c,
.detailsCover {
  position: fixed;
  width: 100%;
  height: 102vh;
  top: 0;
  left: 0;
  opacity: 0;
  pointer-events: none;
}

.coverContainer__c,
.coverContainer {
  height: 100vh;
  position: relative;
  width: clamp(320px, 80%, 900px);
  margin: auto;
  display: grid;
  grid-template-columns: clamp(320px, 100%, 900px);
  grid-template-rows: 1fr 2fr;
}
.dataContainer__c,
.dataContainer {
  position: relative;
  grid-row: 2/-1;
  margin-bottom: 1.5rem;
}

.collapseCover,
.collapseCover__c {
  width: 2rem;
  height: 2rem;
  position: fixed;
  right: 1rem;
  top: 1rem;
  rotate: 45deg;
  font-size: 2rem;
  z-index: 3;
  display: grid;
  place-content: center;
  color: aliceblue;
  font-weight: bold;
}

.expanded {
  opacity: 1;
  pointer-events: auto;
}

.expand,
.expand__c {
  width: 102%;
  height: 100vh;
}
.expand > *,
.expand__c > * {
  display: none;
}

/* SCROLLBAR */

* {
  scrollbar-width: thin;
  scrollbar-color: transparent aliceblue;
}
*::-webkit-scrollbar {
  width: 4px;
}

*::-webkit-scrollbar-track {
  box-shadow: inset 0 0 4px rgba(0, 0, 0, 0.3);
}

*::-webkit-scrollbar-thumb {
  background-color: aliceblue;
  border-radius: 3px;
}

/* BACKGROUND */

.background {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  z-index: -3;
}
.backgroundContainer {
  position: relative;
  top: 0;
  height: 100%;
  width: clamp(320px, 80%, 900px);
  margin: auto;
  z-index: -1;
}
.background__c,
.background__b {
  position: fixed;
  margin: auto;
  width: clamp(320px, 80%, 900px);
  top: 0;
  z-index: -1;
}

.sun {
  position: absolute;
  border-radius: 50%;
  height: 60px;
  width: 60px;
  top: 5rem;
  right: 4rem;
  background-color: rgb(255, 251, 0);
}
.sun::before {
  display: inline-block;
  position: relative;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  content: "";
  border-radius: 50%;
  width: 250px;
  height: 250px;
  background: radial-gradient(
    hsla(60, 100%, 50%, 0.712),
    hsla(60, 100%, 50%, 0) 70%
  );
}
.moon {
  position: absolute;
  border-radius: 50%;
  height: 60px;
  width: 60px;
  top: 5rem;
  right: 4rem;
  background-color: rgb(209, 237, 255);
}
.moon::before {
  display: inline-block;
  position: relative;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  content: "";
  border-radius: 50%;
  width: 150px;
  height: 150px;
  background: radial-gradient(
    hsla(186, 88%, 84%, 0.224),
    hsla(192, 100%, 50%, 0) 70%
  );
}

/* cloud */

.darkCloud,
.thunderCloud,
.cloud {
  /* filter: drop-shadow(5px 5px 0 #0005); */
  height: 17vh;
  width: 17vh;
  position: absolute;
  border-radius: 50%;
  top: 2vh;
  right: 26vw;
  background: linear-gradient(rgb(234, 234, 234), rgb(194, 193, 193));
  border-bottom: 2px solid grey;
  animation: cloudPassBy 20s linear infinite;
  z-index: 3;
}
.darkCloud::before,
.thunderCloud::before,
.cloud::before {
  /* filter: drop-shadow(5px 5px 0 #0005); */
  display: inline-block;
  position: relative;
  content: "";
  width: 12vh;
  height: 12vh;
  border-radius: 50%;
  background: linear-gradient(rgb(234, 234, 234), rgb(194, 193, 193));
  border-bottom: 2px solid grey;
  top: 5vh;
  left: -7vh;
}
.darkCloud::after,
.thunderCloud::after,
.cloud::after {
  /* filter: drop-shadow(5px 5px 0 #0005); */
  display: inline-block;
  position: relative;
  content: "";
  width: 15vh;
  height: 15vh;
  border-radius: 50%;
  background: linear-gradient(rgb(234, 234, 234), rgb(194, 193, 193));
  border-bottom: 2px solid grey;
  top: -10vh;
  left: 10vh;
}
.darkCloud:first-of-type,
.thunderCloud:first-of-type,
.cloud:first-of-type {
  top: 15vh;
  animation: cloudPassBy 20s linear infinite;
  transform: translate(-90vw, 0);
  z-index: 2;
}
.darkCloud:nth-of-type(2),
.thunderCloud:nth-of-type(2),
.cloud:nth-of-type(2) {
  top: 20vh;
  animation: cloudPassBy 20s linear infinite;
  animation-delay: 10s;
  transform: translate(-90vw, 0);
  z-index: 2;
}
.darkCloud:nth-of-type(3),
.thunderCloud:nth-of-type(3),
.cloud:nth-of-type(3) {
  top: 25vh;
  animation: cloudPassBy 20s linear infinite;
  animation-delay: 15s;
  transform: translate(-90vw, 0);
  z-index: 1;
}

/* dark cloud */

.darkCloud::before,
.darkCloud::after,
.darkCloud {
  /* filter: drop-shadow(5px 5px 0 #0005); */
  background: linear-gradient(rgb(124, 124, 124), rgb(80, 80, 80));
}

/* big cloud */

.bigDarkCloud,
.thunderWrapper,
.bigCloud {
  position: absolute;
  top: 0;
  left: -25vw;
  z-index: 4;
  animation: cloudShiftRight 10s ease-in-out infinite;
}
.cloudPart {
  position: absolute;
  border-radius: 50%;
  background: linear-gradient(rgb(234, 234, 234), rgb(194, 193, 193));
  border-bottom: 2px solid grey;
  left: 0;
  top: 0;
}
.cloudPart:first-of-type {
  position: absolute;
  border-radius: 50%;
  background: linear-gradient(rgb(234, 234, 234), rgb(194, 193, 193));
  border-bottom: 2px solid grey;
  left: 0;
  top: -4vw;
}
.cloudPart:first-of-type::after {
  content: "";
  position: absolute;
  border-radius: 50%;
  background: linear-gradient(rgb(234, 234, 234), rgb(194, 193, 193));
  border-bottom: 2px solid grey;
  left: 8.5vw;
  top: 0;
}
.cloudPart:nth-of-type(2) {
  left: 17vw;
  top: -4vw;
}
.cloudPart:nth-of-type(2)::after {
  content: "";
  position: absolute;
  border-radius: 50%;
  background: linear-gradient(rgb(234, 234, 234), rgb(194, 193, 193));
  border-bottom: 2px solid grey;
  left: 8vw;
  top: 0;
}
.cloudPart:nth-of-type(3) {
  left: 40vw;
  top: -3vw;
}
.cloudPart:nth-of-type(3)::before {
  content: "";
  position: absolute;
  border-radius: 50%;
  background: linear-gradient(rgb(234, 234, 234), rgb(194, 193, 193));
  border-bottom: 2px solid grey;
  left: -7vw;
  top: 0;
}
.cloudPart:nth-of-type(3)::after {
  content: "";
  position: absolute;
  border-radius: 50%;
  background: linear-gradient(rgb(234, 234, 234), rgb(194, 193, 193));
  border-bottom: 2px solid grey;
  left: 8vw;
  top: 0;
}

.bigCloud:nth-of-type(2),
.thunderWrapper:nth-of-type(2),
.bigDarkCloud:nth-of-type(2) {
  left: 32vw;
  z-index: 4;
  animation: cloudShiftRight 10s ease-in-out infinite;
}
.bigCloud:nth-of-type(3),
.thunderWrapper:nth-of-type(3),
.bigDarkCloud:nth-of-type(3) {
  top: 9vh;
  left: -25vw;
  z-index: 3;
  animation: cloudShiftLeft 10s ease-in-out infinite;
}
.bigCloud:nth-of-type(4),
.thunderWrapper:nth-of-type(4),
.bigDarkCloud:nth-of-type(4) {
  top: 9vh;
  left: 32vw;
  z-index: 3;
  animation: cloudShiftLeft 10s ease-in-out infinite;
}
.bigCloud:nth-of-type(5),
.thunderWrapper:nth-of-type(5),
.bigDarkCloud:nth-of-type(5) {
  top: 19vh;
  left: -25vw;
  z-index: 2;
  animation: cloudShiftRight 10s ease-in-out infinite;
}
.bigCloud:nth-of-type(6),
.thunderWrapper:nth-of-type(6),
.bigDarkCloud:nth-of-type(6) {
  top: 19vh;
  left: 32vw;
  z-index: 2;
  animation: cloudShiftRight 10s ease-in-out infinite;
}
.bigCloud:nth-of-type(7),
.thunderWrapper:nth-of-type(7),
.bigDarkCloud:nth-of-type(7) {
  top: 27vh;
  left: -25vw;
  z-index: 1;
  animation: cloudShiftLeft 10s ease-in-out infinite;
}
.bigCloud:nth-of-type(8),
.thunderWrapper:nth-of-type(8),
.bigDarkCloud:nth-of-type(8) {
  top: 27vh;
  left: 32vw;
  z-index: 1;
  animation: cloudShiftLeft 10s ease-in-out infinite;
}

/* big dark cloud */

.bigDarkCloud > .cloudPart::after,
.bigDarkCloud > .cloudPart,
.bigDarkCloud > .cloudPart::before {
  background: linear-gradient(rgb(124, 124, 124), rgb(80, 80, 80));
}

/* thunderCloud */

.thunderCloud:first-of-type,
.thunderCloud {
  filter: drop-shadow(5px 5px 0 #0005);
  background: linear-gradient(rgb(124, 124, 124), rgb(80, 80, 80));
  animation: thunderStrike 10s ease infinite,
    cloudPassBy 20s ease-in-out infinite;
}
.thunderCloud::before,
.thunderCloud::after {
  background: linear-gradient(rgb(124, 124, 124), rgb(80, 80, 80));
}
.thunderCloud:nth-of-type(2) {
  animation: thunderStrike 10s ease infinite,
    cloudPassBy 20s ease-in-out infinite;
  animation-delay: 10s;
}
.thunderCloud:nth-of-type(3) {
  animation: thunderStrike 10s ease infinite,
    cloudPassBy 20s ease-in-out infinite;
  animation-delay: 15s;
}

/* bigThunderCloud */

.bigThunderCloud {
  filter: drop-shadow(5px 5px 0 #0005);
}

.bigThunderCloud > .cloudPart::after,
.bigThunderCloud > .cloudPart,
.bigThunderCloud > .cloudPart::before {
  background: linear-gradient(rgb(124, 124, 124), rgb(80, 80, 80));
}

.thunderWrapper:first-of-type .bigThunderCloud {
  animation: thunderStrike 10s ease infinite;
}
.thunderWrapper:nth-of-type(2) .bigThunderCloud {
  animation: thunderStrike 10s ease infinite;
  animation-delay: 12s;
}
.thunderWrapper:nth-of-type(3) .bigThunderCloud {
  animation: thunderStrike 10s ease infinite;
  animation-delay: 18s;
}
.thunderWrapper:nth-of-type(4) .bigThunderCloud {
  animation: thunderStrike 10s ease infinite;
  animation-delay: 15s;
}
.thunderWrapper:nth-of-type(5) .bigThunderCloud {
  animation: thunderStrike 10s ease infinite;
  animation-delay: 23s;
}
.thunderWrapper:nth-of-type(6) .bigThunderCloud {
  animation: thunderStrike 10s ease infinite;
  animation-delay: 29s;
}
.thunderWrapper:nth-of-type(7) .bigThunderCloud {
  animation: thunderStrike 10s ease infinite;
  animation-delay: 34s;
}
.thunderWrapper:nth-of-type(8) .bigThunderCloud {
  animation: thunderStrike 10s ease infinite;
  animation-delay: 38s;
}
.thunderWrapper:nth-of-type(9) .bigThunderCloud {
  animation: thunderStrike 10s ease infinite;
  animation-delay: 43s;
}

/* big clouds resizing */

.bigThunderCloud,
.bigDarkCloud,
.bigCloud {
  height: 20vh;
  width: 50vw;
}
.cloudPart {
  height: clamp(95px, 12vw, 17vw);
  width: clamp(95px, 12vw, 17vw);
}
.cloudPart:first-of-type::after {
  height: clamp(105px, 14vw, 19vw);
  width: clamp(105px, 14vw, 19vw);
}
.cloudPart:nth-of-type(2) {
  height: clamp(89px, 12vw, 16vw);
  width: clamp(89px, 12vw, 16vw);
}
.cloudPart:nth-of-type(2)::after {
  height: clamp(100px, 13vw, 18vw);
  width: clamp(100px, 13vw, 18vw);
}
.cloudPart:nth-of-type(3) {
  height: clamp(90px, 12vw, 17vw);
  width: clamp(90px, 12vw, 17vw);
}
.cloudPart:nth-of-type(3)::before {
  height: clamp(110px, 14vw, 19vw);
  width: clamp(110px, 14vw, 19vw);
}
.cloudPart:nth-of-type(3)::after {
  height: clamp(100px, 13vw, 18vw);
  width: clamp(100px, 13vw, 18vw);
}

/* mist */

.mist {
  position: absolute;
  top: 0;
  left: -30vw;
  width: 130vw;
  height: 100vh;
  background: hsla(0, 0%, 100%, 0.454);
  filter: blur(10px);
}
.mist::before,
.mist::after {
  position: absolute;
  content: "";
  width: 500px;
  height: 500px;
  background: radial-gradient(
    ellipse closest-side,
    rgba(245, 245, 245, 0.315),
    transparent
  );
  border-radius: 50%;
}
.mist::before {
  top: 0;
  left: 0;
  animation: shiftMistLeft 10s linear infinite;
}
.mist::after {
  top: 0;
  right: 0;
  animation: shiftMistRight 10s linear infinite;
}

/* rain */

.drop {
  position: absolute;
  top: 3rem;
  background: rgb(102, 181, 255);
  width: 2px;
  height: 7px;
  animation: dropFall 1s linear infinite;
  rotate: 15deg;
  z-index: -1;
}

/* snow */

.snowflake {
  position: absolute;
  top: 3rem;
  background: white;
  width: 4px;
  height: 4px;
  animation: dropFall 3s linear infinite;
  rotate: 5deg;
  z-index: -1;
}

/* blizzard */

.blizzard {
  position: absolute;
  top: 3rem;
  background: white;
  width: 4px;
  height: 4px;
  animation: dropFall 0.7s linear infinite;
  translate: 5rem;
  z-index: -1;
  rotate: 35deg;
}

/* blowing snow */

.blowingSnowGenerator {
  position: fixed;
  height: 40%;
  right: 0;
  bottom: 0;
}

.blowingSnow {
  position: absolute;
  top: 3rem;
  background: white;
  width: 4px;
  height: 4px;
  animation: blowSomeSnow 1.5s linear infinite;
  rotate: 90deg;
  z-index: -1;
}

/* ice pellets */

.pellets {
  position: absolute;
  top: 3rem;
  background: rgb(255, 255, 255);
  width: 2px;
  height: 7px;
  animation: dropFall 0.7s linear infinite;
  rotate: 15deg;
  z-index: -1;
}

/* BACKGROUND ANIMATION */

@keyframes shiftMistRight {
  0% {
    transform: translate(100vw, 0);
  }
  100% {
    transform: translate(-100vw, 0);
  }
}
@keyframes shiftMistLeft {
  0% {
    transform: translate(-100vw, 50vh);
  }
  100% {
    transform: translate(100vw, 50vh);
  }
}

@keyframes cloudPassBy {
  0% {
    transform: translate(-90vw, 0);
  }
  65% {
    transform: translate(0, 0);
  }
  100% {
    transform: translate(90vw, 0);
  }
}

@keyframes cloudShiftRight {
  0% {
    transform: translate(0, 0);
  }
  50% {
    transform: translate(-10px, -5px);
  }
  100% {
    transform: translate(0, 0);
  }
}
@keyframes cloudShiftLeft {
  0% {
    transform: translate(0, 0);
  }
  50% {
    transform: translate(10px, 10px);
  }
  100% {
    transform: translate(0, 0);
  }
}

@keyframes thunderStrike {
  0% {
    filter: drop-shadow(5px 5px 0 #0005) /* drop-shadow(0 0 0 #fff) */
      brightness(1);
  }
  87% {
    filter: drop-shadow(5px 5px 0 #0005) /* drop-shadow(0 0 0 #fff) */
      brightness(1);
  }
  90% {
    filter: /* drop-shadow(5px 5px 0 #0005) */ drop-shadow(0 0 50px #fff)
      brightness(10);
  }
  92% {
    filter: drop-shadow(5px 5px 0 #0005) /* drop-shadow(0 0 0 #fff) */
      brightness(1);
  }
  97% {
    filter: /* drop-shadow(5px 5px 0 #0005) */ drop-shadow(0 0 50px #fff)
      brightness(10);
  }
  100% {
    filter: drop-shadow(5px 5px 0 #0005) /* drop-shadow(0 0 0 #fff) */
      brightness(1);
  }
}

@keyframes dropFall {
  0% {
    transform: translateY(0);
  }
  100% {
    transform: translateY(100vh);
  }
}
@keyframes blowSomeSnow {
  0% {
    transform: translate(0, 0);
  }
  25% {
    transform: translate(2rem, 25vw);
  }
  75% {
    transform: translate(-2rem, 75vw);
  }
  100% {
    transform: translate(0, 100vw);
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles.css"],"names":[],"mappings":"AAAA;EACE,UAAU;EACV,SAAS;EACT,sBAAsB;AACxB;;AAEA,cAAc;AACd;EACE,kEAAkE;AACpE;;AAEA;;;;;;EAME;;AAEF;EACE,aAAa;EACb,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA,WAAW;;AAEX;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,qBAAqB;AACvB;;AAEA,aAAa;;AAEb;EACE,YAAY;EACZ,aAAa;EACb,eAAe;EACf,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,YAAY;EACZ,cAAc;EACd,oBAAoB;EACpB,uBAAuB;EACvB,SAAS;EACT,mBAAmB;EACnB,iBAAiB;EACjB,UAAU;EACV,uBAAuB;EACvB,YAAY;EACZ,2BAA2B;EAC3B,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,uBAAuB;EACvB,4BAA4B;EAC5B,eAAe;EACf,iBAAiB;EACjB,aAAa;AACf;AACA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,4BAA4B;AAC9B;AACA;EACE,cAAc;EACd,YAAY;EACZ,YAAY;EACZ,WAAW;EACX,WAAW;EACX,uEAAsD;EACtD,+DAA8C;EAC9C,wBAAwB;EACxB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,uBAAuB;AACzB;;AAEA;EACE,UAAU;AACZ;;AAEA,SAAS;;AAET;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,+BAA+B;EAC/B,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,YAAY;EACZ,sCAAsC;AACxC;;AAEA,aAAa;;AAEb;EACE,aAAa;EACb,aAAa;EACb,gCAAgC;EAChC,WAAW;AACb;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,mBAAmB;EACnB,iBAAiB;AACnB;AACA;;EAEE,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;AACnB;AACA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;AACA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;AACb;AACA;;;EAGE,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;;EAEE,iBAAiB;AACnB;AACA;;EAEE,iBAAiB;AACnB;;AAEA,mBAAmB;;AAEnB;EACE,aAAa;EACb,yBAAyB;EACzB,qCAAqC;EACrC,mCAAmC;EACnC,qBAAqB;EACrB,WAAW;EACX,qBAAqB;AACvB;AACA;EACE,iBAAiB;AACnB;;AAEA,WAAW;;AAEX;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,2BAA2B;EAC3B,iBAAiB;EACjB,qBAAqB;AACvB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qBAAqB;EACrB,+BAA+B;AACjC;AACA;EACE,kBAAkB;EAClB,0BAA0B;AAC5B;AACA;EACE,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA,aAAa;;AAEb;;EAEE,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,uCAAuC;EACvC,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;;;EAGE,YAAY;EACZ,WAAW;EACX,eAAe;EACf,aAAa;EACb,0CAA0C;EAC1C,mBAAmB;EACnB,iCAAiC;EACjC,yBAAyB;AAC3B;AACA;;EAEE,sBAAsB;EACtB,iBAAiB;EACjB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;AACrB;AACA;;EAEE,oBAAoB;AACtB;AACA;;EAEE,mBAAmB;EACnB,iBAAiB;EACjB,iBAAiB;EACjB,oBAAoB;AACtB;AACA;EACE,oBAAoB;AACtB;;AAEA,WAAW;;AAEX;EACE,cAAc;EACd,WAAW;EACX,eAAe;EACf,SAAS;EACT,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,YAAY;;AAEZ;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,aAAa;EACb,WAAW;EACX,wCAAwC;EACxC,gBAAgB;EAChB,MAAM;EACN,OAAO;AACT;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,oCAAoC;AACtC;AACA;EACE,aAAa;EACb,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,4CAA4C;AAC9C;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,uBAAuB;EACvB,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,uBAAuB;EACvB,kBAAkB;EAClB,QAAQ;AACV;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,uBAAuB;EACvB,kBAAkB;AACpB;AACA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;AACA;EACE;IACE,yBAAyB;EAC3B;EACA;IACE,uBAAuB;EACzB;AACF;;AAEA,UAAU;;AAEV;;EAEE,eAAe;EACf,WAAW;EACX,aAAa;EACb,MAAM;EACN,OAAO;EACP,UAAU;EACV,oBAAoB;AACtB;;AAEA;;EAEE,aAAa;EACb,kBAAkB;EAClB,+BAA+B;EAC/B,YAAY;EACZ,aAAa;EACb,gDAAgD;EAChD,2BAA2B;AAC7B;AACA;;EAEE,kBAAkB;EAClB,cAAc;EACd,qBAAqB;AACvB;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,WAAW;EACX,SAAS;EACT,aAAa;EACb,eAAe;EACf,UAAU;EACV,aAAa;EACb,qBAAqB;EACrB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,oBAAoB;AACtB;;AAEA;;EAEE,WAAW;EACX,aAAa;AACf;AACA;;EAEE,aAAa;AACf;;AAEA,cAAc;;AAEd;EACE,qBAAqB;EACrB,sCAAsC;AACxC;AACA;EACE,UAAU;AACZ;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA,eAAe;;AAEf;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,aAAa;EACb,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,YAAY;EACZ,+BAA+B;EAC/B,YAAY;EACZ,WAAW;AACb;AACA;;EAEE,eAAe;EACf,YAAY;EACZ,+BAA+B;EAC/B,MAAM;EACN,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,SAAS;EACT,WAAW;EACX,kCAAkC;AACpC;AACA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb;;;GAGC;AACH;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,SAAS;EACT,WAAW;EACX,oCAAoC;AACtC;AACA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb;;;GAGC;AACH;;AAEA,UAAU;;AAEV;;;EAGE,0CAA0C;EAC1C,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,mEAAmE;EACnE,6BAA6B;EAC7B,0CAA0C;EAC1C,UAAU;AACZ;AACA;;;EAGE,0CAA0C;EAC1C,qBAAqB;EACrB,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mEAAmE;EACnE,6BAA6B;EAC7B,QAAQ;EACR,UAAU;AACZ;AACA;;;EAGE,0CAA0C;EAC1C,qBAAqB;EACrB,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mEAAmE;EACnE,6BAA6B;EAC7B,UAAU;EACV,UAAU;AACZ;AACA;;;EAGE,SAAS;EACT,0CAA0C;EAC1C,8BAA8B;EAC9B,UAAU;AACZ;AACA;;;EAGE,SAAS;EACT,0CAA0C;EAC1C,oBAAoB;EACpB,8BAA8B;EAC9B,UAAU;AACZ;AACA;;;EAGE,SAAS;EACT,0CAA0C;EAC1C,oBAAoB;EACpB,8BAA8B;EAC9B,UAAU;AACZ;;AAEA,eAAe;;AAEf;;;EAGE,0CAA0C;EAC1C,gEAAgE;AAClE;;AAEA,cAAc;;AAEd;;;EAGE,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,UAAU;EACV,mDAAmD;AACrD;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,mEAAmE;EACnE,6BAA6B;EAC7B,OAAO;EACP,MAAM;AACR;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,mEAAmE;EACnE,6BAA6B;EAC7B,OAAO;EACP,SAAS;AACX;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,mEAAmE;EACnE,6BAA6B;EAC7B,WAAW;EACX,MAAM;AACR;AACA;EACE,UAAU;EACV,SAAS;AACX;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,mEAAmE;EACnE,6BAA6B;EAC7B,SAAS;EACT,MAAM;AACR;AACA;EACE,UAAU;EACV,SAAS;AACX;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,mEAAmE;EACnE,6BAA6B;EAC7B,UAAU;EACV,MAAM;AACR;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,mEAAmE;EACnE,6BAA6B;EAC7B,SAAS;EACT,MAAM;AACR;;AAEA;;;EAGE,UAAU;EACV,UAAU;EACV,mDAAmD;AACrD;AACA;;;EAGE,QAAQ;EACR,WAAW;EACX,UAAU;EACV,kDAAkD;AACpD;AACA;;;EAGE,QAAQ;EACR,UAAU;EACV,UAAU;EACV,kDAAkD;AACpD;AACA;;;EAGE,SAAS;EACT,WAAW;EACX,UAAU;EACV,mDAAmD;AACrD;AACA;;;EAGE,SAAS;EACT,UAAU;EACV,UAAU;EACV,mDAAmD;AACrD;AACA;;;EAGE,SAAS;EACT,WAAW;EACX,UAAU;EACV,kDAAkD;AACpD;AACA;;;EAGE,SAAS;EACT,UAAU;EACV,UAAU;EACV,kDAAkD;AACpD;;AAEA,mBAAmB;;AAEnB;;;EAGE,gEAAgE;AAClE;;AAEA,iBAAiB;;AAEjB;;EAEE,oCAAoC;EACpC,gEAAgE;EAChE;wCACsC;AACxC;AACA;;EAEE,gEAAgE;AAClE;AACA;EACE;wCACsC;EACtC,oBAAoB;AACtB;AACA;EACE;wCACsC;EACtC,oBAAoB;AACtB;;AAEA,oBAAoB;;AAEpB;EACE,oCAAoC;AACtC;;AAEA;;;EAGE,gEAAgE;AAClE;;AAEA;EACE,0CAA0C;AAC5C;AACA;EACE,0CAA0C;EAC1C,oBAAoB;AACtB;AACA;EACE,0CAA0C;EAC1C,oBAAoB;AACtB;AACA;EACE,0CAA0C;EAC1C,oBAAoB;AACtB;AACA;EACE,0CAA0C;EAC1C,oBAAoB;AACtB;AACA;EACE,0CAA0C;EAC1C,oBAAoB;AACtB;AACA;EACE,0CAA0C;EAC1C,oBAAoB;AACtB;AACA;EACE,0CAA0C;EAC1C,oBAAoB;AACtB;AACA;EACE,0CAA0C;EAC1C,oBAAoB;AACtB;;AAEA,wBAAwB;;AAExB;;;EAGE,YAAY;EACZ,WAAW;AACb;AACA;EACE,+BAA+B;EAC/B,8BAA8B;AAChC;AACA;EACE,gCAAgC;EAChC,+BAA+B;AACjC;AACA;EACE,+BAA+B;EAC/B,8BAA8B;AAChC;AACA;EACE,gCAAgC;EAChC,+BAA+B;AACjC;AACA;EACE,+BAA+B;EAC/B,8BAA8B;AAChC;AACA;EACE,gCAAgC;EAChC,+BAA+B;AACjC;AACA;EACE,gCAAgC;EAChC,+BAA+B;AACjC;;AAEA,SAAS;;AAET;EACE,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,YAAY;EACZ,aAAa;EACb,oCAAoC;EACpC,kBAAkB;AACpB;AACA;;EAEE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb;;;;GAIC;EACD,kBAAkB;AACpB;AACA;EACE,MAAM;EACN,OAAO;EACP,4CAA4C;AAC9C;AACA;EACE,MAAM;EACN,QAAQ;EACR,6CAA6C;AAC/C;;AAEA,SAAS;;AAET;EACE,kBAAkB;EAClB,SAAS;EACT,8BAA8B;EAC9B,UAAU;EACV,WAAW;EACX,sCAAsC;EACtC,aAAa;EACb,WAAW;AACb;;AAEA,SAAS;;AAET;EACE,kBAAkB;EAClB,SAAS;EACT,iBAAiB;EACjB,UAAU;EACV,WAAW;EACX,sCAAsC;EACtC,YAAY;EACZ,WAAW;AACb;;AAEA,aAAa;;AAEb;EACE,kBAAkB;EAClB,SAAS;EACT,iBAAiB;EACjB,UAAU;EACV,WAAW;EACX,wCAAwC;EACxC,eAAe;EACf,WAAW;EACX,aAAa;AACf;;AAEA,iBAAiB;;AAEjB;EACE,eAAe;EACf,WAAW;EACX,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,iBAAiB;EACjB,UAAU;EACV,WAAW;EACX,4CAA4C;EAC5C,aAAa;EACb,WAAW;AACb;;AAEA,gBAAgB;;AAEhB;EACE,kBAAkB;EAClB,SAAS;EACT,8BAA8B;EAC9B,UAAU;EACV,WAAW;EACX,wCAAwC;EACxC,aAAa;EACb,WAAW;AACb;;AAEA,yBAAyB;;AAEzB;EACE;IACE,8BAA8B;EAChC;EACA;IACE,+BAA+B;EACjC;AACF;AACA;EACE;IACE,kCAAkC;EACpC;EACA;IACE,iCAAiC;EACnC;AACF;;AAEA;EACE;IACE,8BAA8B;EAChC;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,6BAA6B;EAC/B;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;EACA;IACE,iCAAiC;EACnC;EACA;IACE,0BAA0B;EAC5B;AACF;AACA;EACE;IACE,0BAA0B;EAC5B;EACA;IACE,gCAAgC;EAClC;EACA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE;mBACe;EACjB;EACA;IACE;mBACe;EACjB;EACA;IACE;oBACgB;EAClB;EACA;IACE;mBACe;EACjB;EACA;IACE;oBACgB;EAClB;EACA;IACE;mBACe;EACjB;AACF;;AAEA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,4BAA4B;EAC9B;AACF;AACA;EACE;IACE,0BAA0B;EAC5B;EACA;IACE,gCAAgC;EAClC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,8BAA8B;EAChC;AACF","sourcesContent":["* {\n  padding: 0;\n  margin: 0;\n  box-sizing: border-box;\n}\n\n/* VARIABLES */\n:root {\n  --BACKGROUND-LG: linear-gradient(rgb(75, 75, 75), rgb(54, 54, 54));\n}\n\n/* \nlinear-gradient(skyblue, rgb(179, 179, 179)); sunny\nlinear-gradient(rgb(28, 24, 55), rgb(17, 15, 32)); clear\nlinear-gradient(rgb(181, 181, 181), rgb(78, 78, 78)); cloudy\nlinear-gradient(rgb(214, 214, 214), rgb(121, 121, 121)); blowing snow\nlinear-gradient(rgb(75, 75, 75), rgb(54, 54, 54)); heavy reain\n */\n\nbody {\n  height: 100vh;\n  background-color: dimgray;\n  overflow: hidden;\n}\n\n/* HEADER */\n\nheader {\n  width: 100%;\n  height: 10vh;\n  display: grid;\n  justify-items: center;\n}\n\n/* SEARCHBR */\n\n.search {\n  width: 300px;\n  display: flex;\n  padding: 0.4rem;\n  height: 50px;\n  color: aliceblue;\n}\n\n.errorElement {\n  display: grid;\n  position: absolute;\n  width: 290px;\n  height: 2.5rem;\n  padding: 0.4rem 1rem;\n  border: 2px solid black;\n  top: 3rem;\n  border-radius: 20px;\n  font-size: 1.3rem;\n  opacity: 0;\n  background-color: white;\n  color: black;\n  transition: opacity 1s ease;\n  z-index: 3;\n}\n\n.searchInput {\n  width: 100%;\n  border: 2px solid black;\n  border-radius: 20px 0 0 20px;\n  padding: 0 1rem;\n  font-size: 1.3rem;\n  outline: none;\n}\n.searchButton {\n  width: 70px;\n  border: none;\n  background: black;\n  border-radius: 0 20px 20px 0;\n}\n.searchButton::after {\n  display: block;\n  margin: auto;\n  height: 35px;\n  width: 35px;\n  content: \"\";\n  -webkit-mask: url(./img/magnify.svg) no-repeat 50% 50%;\n  mask: url(./img/magnify.svg) no-repeat 50% 50%;\n  -webkit-mask-size: cover;\n  mask-size: cover;\n  background-color: white;\n}\n.searchButton:hover {\n  background-color: white;\n}\n.searchButton:hover::after {\n  background-color: black;\n}\n\n.visible {\n  opacity: 1;\n}\n\n/* MAIN */\n\nmain {\n  position: relative;\n}\n\n.mainContainer {\n  height: 100%;\n  width: clamp(320px, 80%, 900px);\n  margin: auto;\n}\n\n.light {\n  color: aliceblue;\n  background: rgba(0, 0, 0, 0.199);\n}\n\n.dark {\n  color: black;\n  background: rgba(240, 248, 255, 0.224);\n}\n\n/* OVERVIEW */\n\n.overviewContainer {\n  padding: 1rem;\n  display: grid;\n  grid-template-columns: 1.5fr 1fr;\n  gap: 0.4rem;\n}\n\n.nameWrapper {\n  display: grid;\n  grid-template-rows: 1fr min-content min-content min-content;\n  align-items: center;\n}\n.locationCity {\n  font-weight: bold;\n  font-size: 1.6rem;\n  align-self: end;\n}\n.locationCountry {\n  font-weight: bolder;\n  font-size: 1.2rem;\n}\n.localDate,\n.localDate__c {\n  font-size: 1.5rem;\n  font-weight: bold;\n  align-self: start;\n}\n.localTime {\n  font-weight: bold;\n  font-size: 1.2rem;\n}\n.weatherType {\n  font-size: 1.2rem;\n  font-weight: bold;\n}\n\n.weatherWrapper {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  place-items: center;\n  gap: 0.2rem;\n}\n.temperature,\n.temperature__b,\n.temperature__c {\n  font-weight: bold;\n  font-size: 2.5rem;\n  grid-column: 1 /-1;\n}\n.currentWeatherImg {\n  border-radius: 10px;\n}\n.localTime,\n.localTime__c {\n  font-size: 1.2rem;\n}\n.UV,\n.UV__c {\n  font-size: 1.2rem;\n}\n\n/* WEATHERDETAILS */\n\n.weatherDetailsContainer {\n  display: grid;\n  padding: 0 1rem 1rem 1rem;\n  grid-template-columns: repeat(3, 1fr);\n  grid-template-rows: repeat(3, 2rem);\n  place-content: center;\n  gap: 0.5rem;\n  white-space: pre-line;\n}\n.WDSpan {\n  font-weight: bold;\n}\n\n/* TOGGEL */\n\n.toggleComponent {\n  position: relative;\n  width: 2.5rem;\n  height: min-content;\n  border-radius: 20px;\n  border: 2px solid aliceblue;\n  background: black;\n  margin: 0 1rem 0 1rem;\n}\n.toggleBtn {\n  position: relative;\n  width: 1rem;\n  height: 1rem;\n  border-radius: 50%;\n  background: aliceblue;\n  transition: transform 0.5s ease;\n}\n.left {\n  position: relative;\n  transform: translate(0rem);\n}\n.right {\n  position: relative;\n  transform: translate(1.3rem);\n}\n\n.btnWrapper {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n}\n.showoff {\n  width: max-content;\n  padding: 0.1rem;\n  height: 1.3rem;\n  border-radius: 20px;\n}\n\n/* FORECAST */\n\n.forecastContainer,\n.forecastContainer__c {\n  margin: 1rem;\n  height: min-content;\n  overflow-y: hidden;\n  overflow-x: auto;\n  display: grid;\n  grid-template-columns: repeat(24, 7rem);\n  border: 2px solid aliceblue;\n  color: aliceblue;\n}\n\n.hourElement,\n.dayElement,\n.hourElement__c {\n  height: 25vh;\n  width: 7rem;\n  padding: 0.4rem;\n  display: grid;\n  grid-template-rows: repeat(4, min-content);\n  place-items: center;\n  border-right: 2px solid aliceblue;\n  transition: all 0.7s ease;\n}\n.hour,\n.day {\n  padding-bottom: 0.2rem;\n  font-weight: bold;\n  font-size: 1rem;\n  pointer-events: none;\n  white-space: nowrap;\n}\n.hourIcon,\n.dayIcon {\n  pointer-events: none;\n}\n.hourTemp,\n.dayTemp {\n  padding-top: 0.2rem;\n  font-weight: bold;\n  font-size: 1.2rem;\n  pointer-events: none;\n}\n.wind {\n  pointer-events: none;\n}\n\n/* FOOTER */\n\nfooter {\n  height: 1.5rem;\n  width: 100%;\n  position: fixed;\n  bottom: 0;\n  display: grid;\n  justify-items: center;\n}\n\n.footerA:any-link {\n  color: aliceblue;\n}\n\n/* SPINNIE */\n\n.spinnieContainer {\n  display: none;\n  position: fixed;\n  place-items: center;\n  height: 100vh;\n  width: 100%;\n  background-color: hsla(0, 0%, 0%, 0.749);\n  overflow: hidden;\n  top: 0;\n  left: 0;\n}\n\n.spinnie {\n  display: grid;\n  place-content: center;\n  position: relative;\n  height: 200px;\n  width: 200px;\n  border-radius: 50%;\n  animation: rotate 2s linear infinite;\n}\n.spinnieOpposite {\n  display: grid;\n  position: relative;\n  height: 150px;\n  width: 150px;\n  border-radius: 50%;\n  animation: rotateOpposite 1s linear infinite;\n}\n.spinnie::before {\n  position: absolute;\n  content: \"\";\n  height: 20px;\n  width: 20px;\n  background-color: white;\n  border-radius: 50%;\n}\n.spinnie::after {\n  position: absolute;\n  content: \"\";\n  height: 20px;\n  width: 20px;\n  background-color: white;\n  border-radius: 50%;\n  right: 0;\n}\n.spinnieOpposite::before {\n  position: absolute;\n  content: \"\";\n  height: 20px;\n  width: 20px;\n  background-color: white;\n  border-radius: 50%;\n}\n.spinnieOpposite::after {\n  justify-self: right;\n  position: absolute;\n  content: \"\";\n  height: 20px;\n  width: 20px;\n  background-color: white;\n  border-radius: 50%;\n}\n\n@keyframes rotate {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n@keyframes rotateOpposite {\n  0% {\n    transform: rotate(360deg);\n  }\n  100% {\n    transform: rotate(0deg);\n  }\n}\n\n/* COVER */\n\n.detailsCover__c,\n.detailsCover {\n  position: fixed;\n  width: 100%;\n  height: 102vh;\n  top: 0;\n  left: 0;\n  opacity: 0;\n  pointer-events: none;\n}\n\n.coverContainer__c,\n.coverContainer {\n  height: 100vh;\n  position: relative;\n  width: clamp(320px, 80%, 900px);\n  margin: auto;\n  display: grid;\n  grid-template-columns: clamp(320px, 100%, 900px);\n  grid-template-rows: 1fr 2fr;\n}\n.dataContainer__c,\n.dataContainer {\n  position: relative;\n  grid-row: 2/-1;\n  margin-bottom: 1.5rem;\n}\n\n.collapseCover,\n.collapseCover__c {\n  width: 2rem;\n  height: 2rem;\n  position: fixed;\n  right: 1rem;\n  top: 1rem;\n  rotate: 45deg;\n  font-size: 2rem;\n  z-index: 3;\n  display: grid;\n  place-content: center;\n  color: aliceblue;\n  font-weight: bold;\n}\n\n.expanded {\n  opacity: 1;\n  pointer-events: auto;\n}\n\n.expand,\n.expand__c {\n  width: 102%;\n  height: 100vh;\n}\n.expand > *,\n.expand__c > * {\n  display: none;\n}\n\n/* SCROLLBAR */\n\n* {\n  scrollbar-width: thin;\n  scrollbar-color: transparent aliceblue;\n}\n*::-webkit-scrollbar {\n  width: 4px;\n}\n\n*::-webkit-scrollbar-track {\n  box-shadow: inset 0 0 4px rgba(0, 0, 0, 0.3);\n}\n\n*::-webkit-scrollbar-thumb {\n  background-color: aliceblue;\n  border-radius: 3px;\n}\n\n/* BACKGROUND */\n\n.background {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100vh;\n  z-index: -3;\n}\n.backgroundContainer {\n  position: relative;\n  top: 0;\n  height: 100%;\n  width: clamp(320px, 80%, 900px);\n  margin: auto;\n  z-index: -1;\n}\n.background__c,\n.background__b {\n  position: fixed;\n  margin: auto;\n  width: clamp(320px, 80%, 900px);\n  top: 0;\n  z-index: -1;\n}\n\n.sun {\n  position: absolute;\n  border-radius: 50%;\n  height: 60px;\n  width: 60px;\n  top: 5rem;\n  right: 4rem;\n  background-color: rgb(255, 251, 0);\n}\n.sun::before {\n  display: inline-block;\n  position: relative;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  content: \"\";\n  border-radius: 50%;\n  width: 250px;\n  height: 250px;\n  background: radial-gradient(\n    hsla(60, 100%, 50%, 0.712),\n    hsla(60, 100%, 50%, 0) 70%\n  );\n}\n.moon {\n  position: absolute;\n  border-radius: 50%;\n  height: 60px;\n  width: 60px;\n  top: 5rem;\n  right: 4rem;\n  background-color: rgb(209, 237, 255);\n}\n.moon::before {\n  display: inline-block;\n  position: relative;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  content: \"\";\n  border-radius: 50%;\n  width: 150px;\n  height: 150px;\n  background: radial-gradient(\n    hsla(186, 88%, 84%, 0.224),\n    hsla(192, 100%, 50%, 0) 70%\n  );\n}\n\n/* cloud */\n\n.darkCloud,\n.thunderCloud,\n.cloud {\n  /* filter: drop-shadow(5px 5px 0 #0005); */\n  height: 17vh;\n  width: 17vh;\n  position: absolute;\n  border-radius: 50%;\n  top: 2vh;\n  right: 26vw;\n  background: linear-gradient(rgb(234, 234, 234), rgb(194, 193, 193));\n  border-bottom: 2px solid grey;\n  animation: cloudPassBy 20s linear infinite;\n  z-index: 3;\n}\n.darkCloud::before,\n.thunderCloud::before,\n.cloud::before {\n  /* filter: drop-shadow(5px 5px 0 #0005); */\n  display: inline-block;\n  position: relative;\n  content: \"\";\n  width: 12vh;\n  height: 12vh;\n  border-radius: 50%;\n  background: linear-gradient(rgb(234, 234, 234), rgb(194, 193, 193));\n  border-bottom: 2px solid grey;\n  top: 5vh;\n  left: -7vh;\n}\n.darkCloud::after,\n.thunderCloud::after,\n.cloud::after {\n  /* filter: drop-shadow(5px 5px 0 #0005); */\n  display: inline-block;\n  position: relative;\n  content: \"\";\n  width: 15vh;\n  height: 15vh;\n  border-radius: 50%;\n  background: linear-gradient(rgb(234, 234, 234), rgb(194, 193, 193));\n  border-bottom: 2px solid grey;\n  top: -10vh;\n  left: 10vh;\n}\n.darkCloud:first-of-type,\n.thunderCloud:first-of-type,\n.cloud:first-of-type {\n  top: 15vh;\n  animation: cloudPassBy 20s linear infinite;\n  transform: translate(-90vw, 0);\n  z-index: 2;\n}\n.darkCloud:nth-of-type(2),\n.thunderCloud:nth-of-type(2),\n.cloud:nth-of-type(2) {\n  top: 20vh;\n  animation: cloudPassBy 20s linear infinite;\n  animation-delay: 10s;\n  transform: translate(-90vw, 0);\n  z-index: 2;\n}\n.darkCloud:nth-of-type(3),\n.thunderCloud:nth-of-type(3),\n.cloud:nth-of-type(3) {\n  top: 25vh;\n  animation: cloudPassBy 20s linear infinite;\n  animation-delay: 15s;\n  transform: translate(-90vw, 0);\n  z-index: 1;\n}\n\n/* dark cloud */\n\n.darkCloud::before,\n.darkCloud::after,\n.darkCloud {\n  /* filter: drop-shadow(5px 5px 0 #0005); */\n  background: linear-gradient(rgb(124, 124, 124), rgb(80, 80, 80));\n}\n\n/* big cloud */\n\n.bigDarkCloud,\n.thunderWrapper,\n.bigCloud {\n  position: absolute;\n  top: 0;\n  left: -25vw;\n  z-index: 4;\n  animation: cloudShiftRight 10s ease-in-out infinite;\n}\n.cloudPart {\n  position: absolute;\n  border-radius: 50%;\n  background: linear-gradient(rgb(234, 234, 234), rgb(194, 193, 193));\n  border-bottom: 2px solid grey;\n  left: 0;\n  top: 0;\n}\n.cloudPart:first-of-type {\n  position: absolute;\n  border-radius: 50%;\n  background: linear-gradient(rgb(234, 234, 234), rgb(194, 193, 193));\n  border-bottom: 2px solid grey;\n  left: 0;\n  top: -4vw;\n}\n.cloudPart:first-of-type::after {\n  content: \"\";\n  position: absolute;\n  border-radius: 50%;\n  background: linear-gradient(rgb(234, 234, 234), rgb(194, 193, 193));\n  border-bottom: 2px solid grey;\n  left: 8.5vw;\n  top: 0;\n}\n.cloudPart:nth-of-type(2) {\n  left: 17vw;\n  top: -4vw;\n}\n.cloudPart:nth-of-type(2)::after {\n  content: \"\";\n  position: absolute;\n  border-radius: 50%;\n  background: linear-gradient(rgb(234, 234, 234), rgb(194, 193, 193));\n  border-bottom: 2px solid grey;\n  left: 8vw;\n  top: 0;\n}\n.cloudPart:nth-of-type(3) {\n  left: 40vw;\n  top: -3vw;\n}\n.cloudPart:nth-of-type(3)::before {\n  content: \"\";\n  position: absolute;\n  border-radius: 50%;\n  background: linear-gradient(rgb(234, 234, 234), rgb(194, 193, 193));\n  border-bottom: 2px solid grey;\n  left: -7vw;\n  top: 0;\n}\n.cloudPart:nth-of-type(3)::after {\n  content: \"\";\n  position: absolute;\n  border-radius: 50%;\n  background: linear-gradient(rgb(234, 234, 234), rgb(194, 193, 193));\n  border-bottom: 2px solid grey;\n  left: 8vw;\n  top: 0;\n}\n\n.bigCloud:nth-of-type(2),\n.thunderWrapper:nth-of-type(2),\n.bigDarkCloud:nth-of-type(2) {\n  left: 32vw;\n  z-index: 4;\n  animation: cloudShiftRight 10s ease-in-out infinite;\n}\n.bigCloud:nth-of-type(3),\n.thunderWrapper:nth-of-type(3),\n.bigDarkCloud:nth-of-type(3) {\n  top: 9vh;\n  left: -25vw;\n  z-index: 3;\n  animation: cloudShiftLeft 10s ease-in-out infinite;\n}\n.bigCloud:nth-of-type(4),\n.thunderWrapper:nth-of-type(4),\n.bigDarkCloud:nth-of-type(4) {\n  top: 9vh;\n  left: 32vw;\n  z-index: 3;\n  animation: cloudShiftLeft 10s ease-in-out infinite;\n}\n.bigCloud:nth-of-type(5),\n.thunderWrapper:nth-of-type(5),\n.bigDarkCloud:nth-of-type(5) {\n  top: 19vh;\n  left: -25vw;\n  z-index: 2;\n  animation: cloudShiftRight 10s ease-in-out infinite;\n}\n.bigCloud:nth-of-type(6),\n.thunderWrapper:nth-of-type(6),\n.bigDarkCloud:nth-of-type(6) {\n  top: 19vh;\n  left: 32vw;\n  z-index: 2;\n  animation: cloudShiftRight 10s ease-in-out infinite;\n}\n.bigCloud:nth-of-type(7),\n.thunderWrapper:nth-of-type(7),\n.bigDarkCloud:nth-of-type(7) {\n  top: 27vh;\n  left: -25vw;\n  z-index: 1;\n  animation: cloudShiftLeft 10s ease-in-out infinite;\n}\n.bigCloud:nth-of-type(8),\n.thunderWrapper:nth-of-type(8),\n.bigDarkCloud:nth-of-type(8) {\n  top: 27vh;\n  left: 32vw;\n  z-index: 1;\n  animation: cloudShiftLeft 10s ease-in-out infinite;\n}\n\n/* big dark cloud */\n\n.bigDarkCloud > .cloudPart::after,\n.bigDarkCloud > .cloudPart,\n.bigDarkCloud > .cloudPart::before {\n  background: linear-gradient(rgb(124, 124, 124), rgb(80, 80, 80));\n}\n\n/* thunderCloud */\n\n.thunderCloud:first-of-type,\n.thunderCloud {\n  filter: drop-shadow(5px 5px 0 #0005);\n  background: linear-gradient(rgb(124, 124, 124), rgb(80, 80, 80));\n  animation: thunderStrike 10s ease infinite,\n    cloudPassBy 20s ease-in-out infinite;\n}\n.thunderCloud::before,\n.thunderCloud::after {\n  background: linear-gradient(rgb(124, 124, 124), rgb(80, 80, 80));\n}\n.thunderCloud:nth-of-type(2) {\n  animation: thunderStrike 10s ease infinite,\n    cloudPassBy 20s ease-in-out infinite;\n  animation-delay: 10s;\n}\n.thunderCloud:nth-of-type(3) {\n  animation: thunderStrike 10s ease infinite,\n    cloudPassBy 20s ease-in-out infinite;\n  animation-delay: 15s;\n}\n\n/* bigThunderCloud */\n\n.bigThunderCloud {\n  filter: drop-shadow(5px 5px 0 #0005);\n}\n\n.bigThunderCloud > .cloudPart::after,\n.bigThunderCloud > .cloudPart,\n.bigThunderCloud > .cloudPart::before {\n  background: linear-gradient(rgb(124, 124, 124), rgb(80, 80, 80));\n}\n\n.thunderWrapper:first-of-type .bigThunderCloud {\n  animation: thunderStrike 10s ease infinite;\n}\n.thunderWrapper:nth-of-type(2) .bigThunderCloud {\n  animation: thunderStrike 10s ease infinite;\n  animation-delay: 12s;\n}\n.thunderWrapper:nth-of-type(3) .bigThunderCloud {\n  animation: thunderStrike 10s ease infinite;\n  animation-delay: 18s;\n}\n.thunderWrapper:nth-of-type(4) .bigThunderCloud {\n  animation: thunderStrike 10s ease infinite;\n  animation-delay: 15s;\n}\n.thunderWrapper:nth-of-type(5) .bigThunderCloud {\n  animation: thunderStrike 10s ease infinite;\n  animation-delay: 23s;\n}\n.thunderWrapper:nth-of-type(6) .bigThunderCloud {\n  animation: thunderStrike 10s ease infinite;\n  animation-delay: 29s;\n}\n.thunderWrapper:nth-of-type(7) .bigThunderCloud {\n  animation: thunderStrike 10s ease infinite;\n  animation-delay: 34s;\n}\n.thunderWrapper:nth-of-type(8) .bigThunderCloud {\n  animation: thunderStrike 10s ease infinite;\n  animation-delay: 38s;\n}\n.thunderWrapper:nth-of-type(9) .bigThunderCloud {\n  animation: thunderStrike 10s ease infinite;\n  animation-delay: 43s;\n}\n\n/* big clouds resizing */\n\n.bigThunderCloud,\n.bigDarkCloud,\n.bigCloud {\n  height: 20vh;\n  width: 50vw;\n}\n.cloudPart {\n  height: clamp(95px, 12vw, 17vw);\n  width: clamp(95px, 12vw, 17vw);\n}\n.cloudPart:first-of-type::after {\n  height: clamp(105px, 14vw, 19vw);\n  width: clamp(105px, 14vw, 19vw);\n}\n.cloudPart:nth-of-type(2) {\n  height: clamp(89px, 12vw, 16vw);\n  width: clamp(89px, 12vw, 16vw);\n}\n.cloudPart:nth-of-type(2)::after {\n  height: clamp(100px, 13vw, 18vw);\n  width: clamp(100px, 13vw, 18vw);\n}\n.cloudPart:nth-of-type(3) {\n  height: clamp(90px, 12vw, 17vw);\n  width: clamp(90px, 12vw, 17vw);\n}\n.cloudPart:nth-of-type(3)::before {\n  height: clamp(110px, 14vw, 19vw);\n  width: clamp(110px, 14vw, 19vw);\n}\n.cloudPart:nth-of-type(3)::after {\n  height: clamp(100px, 13vw, 18vw);\n  width: clamp(100px, 13vw, 18vw);\n}\n\n/* mist */\n\n.mist {\n  position: absolute;\n  top: 0;\n  left: -30vw;\n  width: 130vw;\n  height: 100vh;\n  background: hsla(0, 0%, 100%, 0.454);\n  filter: blur(10px);\n}\n.mist::before,\n.mist::after {\n  position: absolute;\n  content: \"\";\n  width: 500px;\n  height: 500px;\n  background: radial-gradient(\n    ellipse closest-side,\n    rgba(245, 245, 245, 0.315),\n    transparent\n  );\n  border-radius: 50%;\n}\n.mist::before {\n  top: 0;\n  left: 0;\n  animation: shiftMistLeft 10s linear infinite;\n}\n.mist::after {\n  top: 0;\n  right: 0;\n  animation: shiftMistRight 10s linear infinite;\n}\n\n/* rain */\n\n.drop {\n  position: absolute;\n  top: 3rem;\n  background: rgb(102, 181, 255);\n  width: 2px;\n  height: 7px;\n  animation: dropFall 1s linear infinite;\n  rotate: 15deg;\n  z-index: -1;\n}\n\n/* snow */\n\n.snowflake {\n  position: absolute;\n  top: 3rem;\n  background: white;\n  width: 4px;\n  height: 4px;\n  animation: dropFall 3s linear infinite;\n  rotate: 5deg;\n  z-index: -1;\n}\n\n/* blizzard */\n\n.blizzard {\n  position: absolute;\n  top: 3rem;\n  background: white;\n  width: 4px;\n  height: 4px;\n  animation: dropFall 0.7s linear infinite;\n  translate: 5rem;\n  z-index: -1;\n  rotate: 35deg;\n}\n\n/* blowing snow */\n\n.blowingSnowGenerator {\n  position: fixed;\n  height: 40%;\n  right: 0;\n  bottom: 0;\n}\n\n.blowingSnow {\n  position: absolute;\n  top: 3rem;\n  background: white;\n  width: 4px;\n  height: 4px;\n  animation: blowSomeSnow 1.5s linear infinite;\n  rotate: 90deg;\n  z-index: -1;\n}\n\n/* ice pellets */\n\n.pellets {\n  position: absolute;\n  top: 3rem;\n  background: rgb(255, 255, 255);\n  width: 2px;\n  height: 7px;\n  animation: dropFall 0.7s linear infinite;\n  rotate: 15deg;\n  z-index: -1;\n}\n\n/* BACKGROUND ANIMATION */\n\n@keyframes shiftMistRight {\n  0% {\n    transform: translate(100vw, 0);\n  }\n  100% {\n    transform: translate(-100vw, 0);\n  }\n}\n@keyframes shiftMistLeft {\n  0% {\n    transform: translate(-100vw, 50vh);\n  }\n  100% {\n    transform: translate(100vw, 50vh);\n  }\n}\n\n@keyframes cloudPassBy {\n  0% {\n    transform: translate(-90vw, 0);\n  }\n  65% {\n    transform: translate(0, 0);\n  }\n  100% {\n    transform: translate(90vw, 0);\n  }\n}\n\n@keyframes cloudShiftRight {\n  0% {\n    transform: translate(0, 0);\n  }\n  50% {\n    transform: translate(-10px, -5px);\n  }\n  100% {\n    transform: translate(0, 0);\n  }\n}\n@keyframes cloudShiftLeft {\n  0% {\n    transform: translate(0, 0);\n  }\n  50% {\n    transform: translate(10px, 10px);\n  }\n  100% {\n    transform: translate(0, 0);\n  }\n}\n\n@keyframes thunderStrike {\n  0% {\n    filter: drop-shadow(5px 5px 0 #0005) /* drop-shadow(0 0 0 #fff) */\n      brightness(1);\n  }\n  87% {\n    filter: drop-shadow(5px 5px 0 #0005) /* drop-shadow(0 0 0 #fff) */\n      brightness(1);\n  }\n  90% {\n    filter: /* drop-shadow(5px 5px 0 #0005) */ drop-shadow(0 0 50px #fff)\n      brightness(10);\n  }\n  92% {\n    filter: drop-shadow(5px 5px 0 #0005) /* drop-shadow(0 0 0 #fff) */\n      brightness(1);\n  }\n  97% {\n    filter: /* drop-shadow(5px 5px 0 #0005) */ drop-shadow(0 0 50px #fff)\n      brightness(10);\n  }\n  100% {\n    filter: drop-shadow(5px 5px 0 #0005) /* drop-shadow(0 0 0 #fff) */\n      brightness(1);\n  }\n}\n\n@keyframes dropFall {\n  0% {\n    transform: translateY(0);\n  }\n  100% {\n    transform: translateY(100vh);\n  }\n}\n@keyframes blowSomeSnow {\n  0% {\n    transform: translate(0, 0);\n  }\n  25% {\n    transform: translate(2rem, 25vw);\n  }\n  75% {\n    transform: translate(-2rem, 75vw);\n  }\n  100% {\n    transform: translate(0, 100vw);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
